export default "__VITE_ASSET__S$xjSlk3__"